(function($){
  $(function(){
 
   // 開く：.c-modal__trigger の data-modal と同じ data-modal を持つ .c-modal__wrapper を表示
   $(document).on('click', '.c-modal__trigger', function(e){
    e.preventDefault();
    var modalId = $(this).data('modal');
    var $target = $('.c-modal__wrapper[data-modal="' + modalId + '"]');
    if(!$target.length){ return; }
    $target.fadeIn(200);
    $target.find('.c-modal__container').scrollTop(0);
    $('html, body').css('overflow','hidden');
   });
 
   // 閉じる：背景(.c-modal__layer) or 閉じるボタン(.c-modal__close)
   $(document).on('click', '.c-modal__layer, .c-modal__close', function(e){
    e.preventDefault();
    var $wrap = $(this).closest('.c-modal__wrapper');
    $wrap.fadeOut(200);
    $('html, body').removeAttr('style');
   });
 
   // Escキーでも閉じる
   $(document).on('keydown', function(e){
    if(e.key === 'Escape'){
     $('.c-modal__wrapper:visible').fadeOut(200);
     $('html, body').removeAttr('style');
    }
   });
 
  });
 })(jQuery);
 